/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Heating_Curve_Box_Version_Not_CompatibleInputs */



/**
* | output |
* | --- |
* | "At least 60% of valves must be in version >= {version}" |
*
* @param {Heating_Curve_Box_Version_Not_CompatibleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_box_version_not_compatible = /** @type {((inputs: Heating_Curve_Box_Version_Not_CompatibleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_Box_Version_Not_CompatibleInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`At least 60% of valves must be in version >= ${i?.version}`)
	return /** @type {LocalizedString} */ (`Au moins 60% des têtes th. doivent être en version >= ${i?.version}`)
});